export const getPreviewResultStyles = (_, { palette = {} }) => ({
  '@keyframes animationIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  // Base container styles for default (large) screens
  resultContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    '& .result-title': {
      fontSize: '56px',
      fontWeight: 600,
      lineHeight: '64px',
      textAlign: 'center',
      margin: '0px 20px',
    },
  },
  // Large screen specific styles
  'resultContainer-l': {
    width: '90%',
    maxWidth: '1000px',
    '& .result-title': {
      fontSize: '48px',
      lineHeight: '56px',
    },
  },
  // Medium screen specific styles
  'resultContainer-m': {
    width: '80%',
    maxWidth: '800px',
    '& .result-title': {
      fontSize: '40px',
      lineHeight: '48px',
    },
  },
  // Small screen specific styles
  'resultContainer-s': {
    width: '360px',
    '& .result-title-container': {
      width: '360px',
    },
    '& .result-title': {
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: '35px',
      textAlign: 'center',
      margin: '0px 20px',
    },
  },
  inputsContainer: {
    zIndex: 1,
    animation: '$animationIn 0.8s forwards',
    margin: '48px',
    width: '100%',
    maxWidth: '1058px',
    minHeight: '213px',
    display: 'flex',
    flexDirection: 'column',
  },
  'inputsContainer-l': {
    width: '80%',
  },
  'inputsContainer-m': {
    width: '80%',
  },
  'inputsContainer-s': {
    margin: '48px 0 16px 0',
    minHeight: 'auto',
  },
  suggestionsContainer: {
    animation: '$animationIn 0.8s forwards',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0px 48px 48px 48px',
  },
  'suggestionsContainer-l': {
    flexDirection: 'column-reverse',
    alignItems: 'center',
  },
  'suggestionsContainer-m': {
    flexDirection: 'column-reverse',
    alignItems: 'center',
  },
  'suggestionsContainer-s': {
    flexDirection: 'column-reverse',
    alignItems: 'center',
  },
  introContainer: {
    flex: 1,
    marginRight: '80px',
    maxWidth: '540px',
    '& .intro-title': {
      fontSize: '28px',
      lineHeight: '36px',
      fontWeight: 600,
    },
    '& .intro-description': {
      fontSize: '20px',
      lineHeight: '28px',
      margin: '12px 0px',
      color: '#424242',
    },
    '& .channel-title': {
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: 600,
      margin: '12px 0px',
    },
  },
  'introContainer-l': {
    marginRight: '0px',
    marginBottom: '50px',
  },
  'introContainer-m': {
    marginRight: '0px',
    marginBottom: '50px',
  },
  'introContainer-s': {
    marginRight: '0px',
  },
  adPreviewContainer: {
    width: '460px',
    height: '350px',
  },
  'adPreviewContainer-m': {
    width: '100% !important',
  },
  'adPreviewContainer-s': {
    width: '100% !important',
  },
  buttonContainer: {
    display: 'flex',
    '& .create-campaign-button': {
      height: '48px',
      fontSize: '16px',
      padding: '12px 24px',
      backgroundColor: `${palette.black} !important`,
    },
    '& .do-it-later-button': {
      marginLeft: 24,
      height: '48px',
      fontSize: '16px',
      padding: '12px 24px',
    },
  },
  'buttonContainer-m': {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    '& .create-campaign-button': {
      width: '100%',
    },
    '& .do-it-later-button': {
      marginTop: 20,
      marginLeft: 0,
      width: '100%',
    },
  },
  'buttonContainer-s': {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    '& .create-campaign-button': {
      width: '100%',
      fontSize: '24px',
    },
    '& .do-it-later-button': {
      marginTop: 20,
      marginLeft: 0,
      width: '100%',
      fontSize: '24px',
    },
  },
});
